import React from 'react'
import utils from './utils'
import { images } from '../../../../services/assets.services'

function getLevelLayout(width, height, settings, quantities, answer, onEnter) {
    return getLayout(width, height, settings, quantities, answer)
}

function getLayout(gameContainerWidth, gameContainerHeight, settings, quantities, onEnter, onFail) {
    let scale = 0
    let gridBgWidth = 400
    let gridBgHeight = 265
    let cellWidth = 40
    let cellHeight = 26.5
    if (gridBgWidth / gridBgHeight > gameContainerWidth / gameContainerHeight) {
        scale = gameContainerWidth / gridBgWidth
    } else {
        scale = gameContainerHeight / gridBgHeight
    }

    let v1Tens = Math.floor(quantities.value_1 / 10)
    let v1Units = quantities.value_1 % 10
    let v1Path = `M ${0} ${0} `
    if (v1Tens) {
        v1Path += `H ${gridBgWidth} `
        v1Path += `V ${cellHeight * v1Tens} `
        v1Path += `H ${cellWidth * v1Units}`
        v1Path += `V ${cellHeight * (v1Tens + 1)} H ${0}`
    } else {
        v1Path += `H ${cellWidth * v1Units} `
        v1Path += `V ${cellHeight} `
        v1Path += `H ${0} `
    }

    let v2Tens = null
    let v2Units = null
    let v2Path = null

    if (quantities.value_2 && !isNaN(quantities.value_2)) {
        v2Path = `M ${cellWidth * v1Units} ${cellHeight * (v1Tens)} `
        let remainder = 10 - v1Units
        if (quantities.value_2 > remainder) {
            v2Tens = Math.floor((quantities.value_2 - remainder) / 10)
            v2Units = (quantities.value_2 - remainder) % 10
            v2Path += `H ${gridBgWidth} `
            if (v2Tens) {
                v2Path += `V ${cellHeight * (v1Tens + 1 + v2Tens)} `
                v2Path += `H ${cellWidth * v2Units}`
                v2Path += `V ${cellHeight * (v1Tens + 2 + v2Tens)} H ${0}`
                v2Path += `V ${cellHeight * (v1Tens + 1)} `
                v2Path += `H ${cellWidth * v1Units}`
            } else {
                v2Path += `V ${cellHeight * (v1Tens + 1)} `
                v2Path += `H ${cellWidth * v2Units}`
                v2Path += `V ${cellHeight * (v1Tens + 2)} H ${0}`
                v2Path += `V ${cellHeight * (v1Tens + 1)} `
                v2Path += `H ${cellWidth * v1Units}`
            }
        } else {
            v2Units = quantities.value_2 % 10

            v2Path += `H ${cellWidth * v1Units + cellWidth * v2Units} `
            v2Path += `V ${cellHeight * (v1Tens + 1)} `
            v2Path += `H ${cellWidth * v1Units} `
        }
    }

    return (
        <svg
            height={gameContainerHeight}
            width={gameContainerWidth}

        >
            <g transform={`translate(${(gameContainerWidth - gridBgWidth * scale) / 2}, ${(gameContainerHeight - gridBgHeight * scale) / 2}), scale(${scale})`}>
                <path
                    d={v1Path}
                    fill="#E94575"
                    stroke="none"
                //strokeWidth={1}
                />
                {v2Path && <path
                    d={v2Path}
                    fill="#009FE3"
                    stroke="none"
                //strokeWidth={1}
                />}
                <image
                    width={gridBgWidth}
                    height={gridBgHeight}
                    xlinkHref={images.svg['grid']}

                />
            </g>
        </svg>
    )
}

export default {
    getLevelLayout,
}


// WEBPACK FOOTER //
// ./src/components/game/levels/utils/hundredSquare.utils.js